import { resolveResponsiveFactor } from '../../resolvers/ComposedResolvers';
import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveWidth(theme, screenWidth, widthSupport) {
    var result = {};
    if (widthSupport.width !== undefined) {
        result.width = resolveResponsiveFactor(theme, screenWidth, widthSupport.width);
    }
    if (widthSupport.width100) {
        var width100 = resolveResponsiveValue(theme, screenWidth, widthSupport.width100);
        if (width100) {
            result.width = '100%';
        }
    }
    if (widthSupport.maxWidth !== undefined) {
        result.maxWidth = resolveResponsiveFactor(theme, screenWidth, widthSupport.maxWidth);
    }
    if (widthSupport.maxWidth100) {
        var maxWidth100 = resolveResponsiveValue(theme, screenWidth, widthSupport.maxWidth100);
        if (maxWidth100) {
            result.maxWidth = '100%';
        }
    }
    if (widthSupport.minWidth !== undefined) {
        result.minWidth = resolveResponsiveFactor(theme, screenWidth, widthSupport.minWidth);
    }
    if (widthSupport.minWidth100) {
        var minWidth100 = resolveResponsiveValue(theme, screenWidth, widthSupport.minWidth100);
        if (minWidth100) {
            result.minWidth = '100%';
        }
    }
    return result;
}
//# sourceMappingURL=WidthResolver.js.map